import { Edit, Trash } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { NotificationSubscriptionButton } from "@/components/notifications/NotificationSubscriptionButton";
import { FavoriteButton } from "@/components/favorites/FavoriteButton";
import { BackButton } from "@/components/ui/BackButton";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

interface CompanyDetailHeaderProps {
  isEditing: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  handleDelete: () => void;
  companyName: string;
  companyId: string;
}

export const CompanyDetailHeader = ({
  isEditing,
  onEdit,
  onSave,
  onCancel,
  handleDelete,
  companyName,
  companyId
}: CompanyDetailHeaderProps) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="flex justify-between items-center mb-6">
        <BackButton 
          to="/companies" 
          label={t("companies.detail.backToCompanies")} 
        />
        <div className="flex gap-2 pt-2">
          <FavoriteButton
            entityType="company"
            entityId={companyId}
            entityName={companyName}
            variant="outline"
            size="icon"
          />
          <NotificationSubscriptionButton
            entityType="company"
            entityId={companyId}
            entityName={companyName}
            variant="outline"
            size="icon"
          />
          {!isEditing ? (
            <Button 
              variant="outline"
              size="icon"
              className="flex items-center justify-center"
              onClick={onEdit}
              title={t('common.edit')}
            >
              <Edit className="h-4 w-4" />
            </Button>
          ) : null}
          <AlertDialog>
            <AlertDialogTrigger asChild>
              <Button variant="outline" size="icon" className="flex items-center justify-center text-red-600 hover:text-red-700" title={t("common.delete")}>
                <Trash className="h-4 w-4" />
              </Button>
            </AlertDialogTrigger>
            <AlertDialogContent>
              <AlertDialogHeader>
                <AlertDialogTitle>{t("companies.detail.deleteConfirmTitle")}</AlertDialogTitle>
                <AlertDialogDescription>
                  {t("companies.detail.deleteConfirmDescription", { name: companyName })}
                </AlertDialogDescription>
              </AlertDialogHeader>
              <AlertDialogFooter>
                <AlertDialogCancel>{t("common.cancel")}</AlertDialogCancel>
                <AlertDialogAction 
                  onClick={handleDelete}
                  className="bg-red-600 hover:bg-red-700"
                >
                  {t("common.delete")}
                </AlertDialogAction>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialog>
        </div>
      </div>
    </>
  );
}; 